module.exports = __webpack_public_path__ + "images/cv_pickup_efef0f9dab636b824ef71e733afb5f38.png";